<template>
  <v-container>
    <v-skeleton-loader
      :loading="skeleton"
      type="heading, list-item-three-line"
    >
      <v-row>
        <v-col cols="10">
          <v-icon> mdi-account-network </v-icon>
          <span class="headline mx-2">Direct Report</span>
        </v-col> 
        <v-col 
          v-show="$hasPermissionTo(['create employee report to histories']) && !$store.state.isMyProfile" 
          cols="2"
        >
          <!-- <employee-report-to-dialog-edit        
            :employee-uid="employeeUid"
            :user-uid="userUid"
            @updated="loadData"
          /> -->
        </v-col>
      </v-row> 
      <v-row>
        <v-col v-if="reportTo.employee_uid !== undefined">
          <v-list 
            two-line 
            subheader
          >
            <v-list-item>
              <v-list-item-avatar 
                class="mr-4" 
                size="55"
              >
                <img 
                  :src="superior.thumbnail_url" 
                  onerror="this.src='img/thumbnail.jpg'" 
                  alt="Superior Image"
                >
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="px-0">
                  {{ superiorPerson.name }}
                </v-list-item-title>
                <v-list-item-subtitle> {{ isResigned(superior.end_date) ? 'Resigned' : (superior.is_active ? 'Active' : 'On Leave') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col v-else>
          No superior yet
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-icon> mdi-account-multiple </v-icon>
          <span class="headline mx-2">Subordinates</span>        
        </v-col>
      </v-row> 
      <v-row>
        <v-col v-if="noOfSubordinates > 0">
          <v-list 
            two-line 
            subheader
          >
            <v-list-item 
              v-for="subordinate in filteredSubordinates" 
              :key="subordinate.employee_uid"
            >
              <v-list-item-avatar 
                class="mr-4" 
                size="55"
              >
                <img 
                  :src="subordinate.employee.thumbnail_url"                 
                  onerror="this.src='img/thumbnail.jpg'" 
                  alt="Subordinate Image"
                >
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="px-0">
                  {{ subordinate.employee.person.name }}
                </v-list-item-title>
                <v-list-item-subtitle> {{ subordinate.employee.is_active ? 'Active' : 'On Leave' }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>       
          <div v-if="noOfSubordinates >= 6">
            <a 
              v-if="filter" 
              @click.stop="filter = false"
            >Show more ...</a> 
            <a 
              v-else 
              @click.stop="filter = true"
            >Show less ...</a>
          </div>
        </v-col>
        <v-col v-else>
          No subordinates yet
        </v-col>
      </v-row>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
  export default {
    components: {
      // EmployeeReportToDialogEdit: () => import('@/components/employee/report-to/DialogEdit'),
    },
    props: {
      employeeUid: {
        type: String,
        default: null,
      },
      userUid: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        filter: true,
        skeleton: true,
        reportTo: {},
        subordinates: [],
      }
    },
    computed: {
      superior () {
        return (this.reportTo || {})
      },
      superiorPerson () {
        return (this.reportTo.person || {})
      },
      noOfSubordinates () {
        return this.subordinates.length
      },
      filteredSubordinates () {
        if (this.noOfSubordinates < 6) return this.subordinates

        return this.filter ? this.subordinates.slice(0, 5) : this.subordinates
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadData()
          }
        },
      },
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.reportTo().show(this.employeeUid),
          this.$api.subordinates().list(this.employeeUid),
        ])
          .then(([reportTo, subordinates]) => {
            if ((((reportTo.data || {}).person || {}).user || {}).vessel === null) {
              this.reportTo = reportTo.data || {}
            } else {
              this.reportTo = (reportTo.data.report_to || {}).assigned_to_employee || {}
            }

            this.subordinates = subordinates.data || []          
          })
          .catch(() => {})
          .then(() => {
            this.skeleton = false
          })
      },
      isResigned (endDate) {
        return endDate !== null && endDate <= this.$moment().format('YYYY-MM-DD')
      },
    },
  }
</script>
